/* eslint-disable camelcase */
import { SEO_SUFFIX_PT } from './src/utils/SEO';

const seoPt = {
  title: `App Masters - ${SEO_SUFFIX_PT}`,
  description:
    'Empresa de desenvolvimento de apps, softwares e soluções com IA, em Juiz de Fora, MG.',
  openGraph: {
    type: 'website',
    locale: 'pt',
    url: `${process.env.NEXT_PUBLIC_SITE_URL}/pt`,
    site_name: 'App Masters',
    images: [
      {
        url: `${process.env.NEXT_PUBLIC_SITE_URL}appmasters-metaimage.png`,
        width: 800,
        height: 600,
        alt: 'Logo da App Masters',
      },
    ],
  },
};

export default seoPt;
